import { JSX } from 'react';
import { SkeletonPulse } from './SkeletonPulse';
import classes from './VideoSkeleton.module.scss';

export const VideoSkeleton = (): JSX.Element => (
    <SkeletonPulse className={classes.video} width="100%" />
);
